import { BomDto } from "src/dtos/bom/BomDto";

// 검색 조건
export interface SAL6030_R01Filter {
	brandCd: string;
	itemCd: string;
	itemNm: string;
}

// 상단 좌측 - 제품 목록
export interface SAL6030_R01HeaderDto extends BomDto {
	prntItemcd: string;
	itemNm: string;
	itemSpec: string;
	locationCd?: string;
	locationNm?: string;
	modelNo: string;
	contractCost: number;
	smtCost: number;
	totalCost: number;
}

// 상단 우측 - 품목그룹별 원가
export interface SAL6030_R01GroupDto extends BomDto {
	itemGroup: string;
	itemGroupNm: string;
	contractCost: number;
	smtCost: number;
	totalCost: number;
}

// 하단 - 소요자재 원가 상세
export interface SAL6030_R01DetailDto extends BomDto {
	itemNm: string;
	itemSpec: string;
	locationCd?: string;
	locationNm?: string;
	itemGroup: string;
	itemCost: number;
	smtUnitCost: number;
	contractQty: number;
	consignQty: number;
	totalQty: number;
	materialCost: number;
	smtCost: number;
	totalCost: number;
	fixedLoss: number;
	lossRate: number;
	/** 자재공급구분 코드명 */
	materialIntypeNm: string;
}

export const defaultSAL6030_R01Filter: SAL6030_R01Filter = {
	brandCd: '',
	itemCd: '',
	itemNm: '',
};

export const defaultSAL6030_R01HeaderDto: SAL6030_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: '',
	lossPercent: 0,
	remark: '',
	modelNo: '',
	contractCost: 0,
	smtCost: 0,
	totalCost: 0,
	inserted: false,
	isModified: false,
};

export const defaultSAL6030_R01GroupDto: SAL6030_R01GroupDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: '',
	lossPercent: 0,
	remark: '',
	itemGroup: '',
	itemGroupNm: '',
	contractCost: 0,
	smtCost: 0,
	totalCost: 0,
	inserted: false,
	isModified: false,
};

export const defaultSAL6030_R01DetailDto: SAL6030_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	itemGroup: '',
	itemCost: 0,
	smtUnitCost: 0,
	contractQty: 0,
	consignQty: 0,
	totalQty: 0,
	childItemUnit: '',
	materialCost: 0,
	smtCost: 0,
	totalCost: 0,
	fixLossqty: 0,
	fixedLoss: 0,
	lossPercent: 0,
	lossRate: 0,
	remark: '',

	materialIntype: '',
	materialIntypeNm: '',

	inserted: false,
	isModified: false,
};